// Native blocking: toggle block/unblock for a given user
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../../../front/src/components/Button/Button';
import { blockedMessages } from '../../../../front/src/i18n/blocked';
import { useBlockedUsers } from '../../hooks/useBlockedUsers';

type BlockUserOptionProps = {
  userId?: string;
  pseudo?: string;
  picture?: string;
  className?: string;
};

export const BlockUserOption = ({ userId, pseudo, picture, className }: BlockUserOptionProps) => {
  const { isBlocked, block, unblock, isNative } = useBlockedUsers();

  if (!isNative || !userId) return null;

  const blocked = isBlocked(userId);

  const handleToggle = async () => {
    if (blocked) {
      await unblock(userId);
    } else {
      await block({ userId, pseudo, picture });
    }
  };

  return (
    <Button
      variant="secondary"
      className={classNames('py-1 px-3 text-sm', className)}
      onClick={handleToggle}
    >
      <FormattedMessage {...(blocked ? blockedMessages.unblock : blockedMessages.block)} />
    </Button>
  );
};
